import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ToggleButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  marginBottom: 12,
  backgroundColor: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: 8,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease, border-color 0.2s ease',
  '&:hover': {
    backgroundColor: '#f5f5f5',
    borderColor: '#bdbdbd'
  }
});

export const ToggleContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8
});

export const ToggleLabel = styled('span')({
  fontSize: 14,
  fontWeight: 500,
  color: '#333'
});

export const FilterCount = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  padding: '0 6px',
  backgroundColor: '#061923',
  color: '#fff',
  borderRadius: 10,
  fontSize: 12,
  fontWeight: 600
});
